import React from 'react';
import { PlayerAdditionalInfo } from '../playerAdditionalInfo';
import { IPlayer } from '@base/features/player/model/interfaces';
import Tooltip, { TooltipPlacement } from '@ui-kit/components/tooltip';

export default function PopoverPlayerAdditionalInfo(props: {
  player: IPlayer;
  children: JSX.Element & React.ReactNode;
  placement?: TooltipPlacement;
}) {
  return (
    <Tooltip
      overlay={<PlayerAdditionalInfo player={props.player} />}
      placement={props.placement || 'left'}
      trigger="click"
    >
      {props.children}
    </Tooltip>
  );
}
